import * as React from 'react'
import { Avatar, Badge, Card, Col, Row } from 'antd'

import badgeIcon from '../../content/ic_badge_notifica.png'
import "./TileCard.less"

interface TileCardProps {
    onClick: () => void
    icon: React.ReactNode
    highlighted: boolean
}

export const TileCard: React.FC<TileCardProps> = (props) => {
    return <a onClick={() => props.onClick()}>
        {/*<Badge count={<img src={badgeIcon} className="tile-card-badge" />}>*/}
        <Card>
            {props.highlighted ? <img src={badgeIcon} className="tile-card-badge" /> : <></>}
            <Row justify="center" align="middle" className="tile-card-row">
                <Col xl={10} lg={6} sm={4} xs={12}>
                    <Avatar src={props.icon} size={40} className="tile-card-avatar" />
                </Col>
                <Col xl={14} lg={18} sm={20} xs={12}>
                    <span className="Regular16Grey800">{props.children}</span>
                </Col>
            </Row>
            </Card>
        {/*</Badge>*/}
    </a>
}